/**
 * Labstep
 *
 * @module components/DeviceBooking/Manager
 * @desc Device Booking Manager
 */

import { DeviceBookingModal } from 'labstep-web/components/DeviceBooking/Modal';
import DeviceBookingTimeGrid from 'labstep-web/components/DeviceBooking/TimeGrid';
import { withActiveEditModal } from 'labstep-web/containers/ActiveEditModal';
import { DeviceBooking } from 'labstep-web/models/device-booking.model';
import type React from 'react';
import type { DeviceBookingManagerProps } from './types';

export const DeviceBookingManager: React.FC<
  DeviceBookingManagerProps
> = ({ device, activeEditModal, setActiveEditModal }) => (
  <>
    <DeviceBookingTimeGrid device={device} />
    {
      // Need to separate out the modal in case time grid refreshes
      activeEditModal &&
        activeEditModal.entityName === DeviceBooking.entityName && (
          <DeviceBookingModal
            deviceBookingId={activeEditModal.id as number}
            onClose={() => setActiveEditModal(null)}
          />
        )
    }
  </>
);

export default withActiveEditModal(DeviceBookingManager);
